import { useAccount } from '~publish/contexts/AccountContext'
import {
  useIsFreeUser,
  useCurrentOrganization,
} from '~publish/contexts/AccountContext/hooks'
import { isTrialUser } from '~publish/helpers/user'

const ANALYZE_HIDE_CUTOFF_DATE = new Date('2025-11-17T16:49:00').getTime()

export function useIsAnalyzeUpgradePathEnabled(): boolean {
  const isFreeUser = useIsFreeUser()
  const organization = useCurrentOrganization()
  const { account } = useAccount()
  const isTrial = isTrialUser(account)

  const createdAt = organization?.createdAt

  if (!createdAt) {
    return false
  }

  const signUpDate = new Date(createdAt).getTime()

  return signUpDate > ANALYZE_HIDE_CUTOFF_DATE && isFreeUser && !isTrial
}
